import React from 'react';
import { useSelector } from 'react-redux';

import Tag from 'app/shared/components/common/Tag';
import PropTypes from 'prop-types';

import { resolveColor } from 'constants/colors';
import { DEFAULT_MILESTONE_COLOR_NAME } from 'constants/milestones';
import { TagType } from 'constants/tag';
import { COLOR_PALETTE } from 'constants/ui';

import { selectMilestonePresetationSettings } from 'store/milestoneDefinitions/selectors';

const defaultValue = {};

const MilestoneStatusCellRenderer = ({ value = defaultValue, type, isNameKey = false }) => {
  const { name, Id, color } = value || {};

  const milestonePresentationSettings = useSelector(selectMilestonePresetationSettings);

  const id = isNameKey
    ? Object.values(milestonePresentationSettings).find(item => item.name === name)?.id
    : Id;

  const rawColor =
    color ?? milestonePresentationSettings[id]?.color ?? DEFAULT_MILESTONE_COLOR_NAME;
  const resolved = resolveColor(rawColor);
  const backgroundColor = resolved?.bg ?? rawColor;
  const textColor = resolved?.fg ?? COLOR_PALETTE.GRAY[10];
  const tagText = name || 'N/A';

  return (
    <Tag
      dataTruncated
      backgroundColor={backgroundColor}
      borderRadius={8}
      className="truncate"
      color={textColor}
      text={tagText}
      type={type}
    />
  );
};

MilestoneStatusCellRenderer.propTypes = {
  value: PropTypes.object,
  type: PropTypes.oneOf(Object.values(TagType)),
  isNameKey: PropTypes.bool,
};

export default MilestoneStatusCellRenderer;
